/* DDUDDI home/collection JS (loaded via footer-group dd_css) */
(function () {
  /* 1) NEW IN / hero line-bar: set active (dark) segment on load, guarding the
        section's NaN-on-load bug. */
  function fixTracks() {
    document.querySelectorAll('[data-dd-track]').forEach(function (t) {
      var sc = document.getElementById(t.getAttribute('data-dd-track'));
      if (!sc) return;
      var segs = t.querySelectorAll('.dd-seg');
      if (!segs.length) return;
      var sl = sc.querySelector('.dd-slide');
      var w = sl ? sl.getBoundingClientRect().width : 0;
      var idx = w ? Math.round(sc.scrollLeft / w) : 0;
      if (!(idx >= 0)) idx = 0;
      for (var i = 0; i < segs.length; i++) { segs[i].classList.toggle('is-active', i === idx); }
    });
  }

  /* 2) Collection: show a compact page-number nav at the top-right, next to
        the breadcrumb bar directly above the product grid (dd-collection-topbar,
        rendered in main-collection-product-grid.liquid), mirroring Dawn's
        native pagination. The bottom pagination (with first/last jump
        buttons) stays visible too - this is an additional shortcut, not a
        replacement. */
  function injectPageNavCss() {
    if (document.getElementById('dd-pagenav-css')) return;
    var css = ''
      + '.dd-pagenav{display:flex;gap:.2rem;align-items:center}'
      + '.dd-pagenav a,.dd-pagenav span{min-width:2.3rem;height:2.3rem;display:inline-flex;align-items:center;justify-content:center;padding:0 .4rem;font-size:1.2rem;line-height:1;color:#9a9a9a;text-decoration:none;border:1px solid transparent;border-radius:0}'
      + '.dd-pagenav a:hover{color:#1e1e1e}'
      + '.dd-pagenav .is-current{color:#1e1e1e;border-color:#e5e5e5}'
      + '.collection .product-grid.dd-grid{display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;column-gap:0!important;row-gap:8rem!important}'
      + '.collection .product-grid.dd-grid>li,.collection .product-grid.dd-grid>.grid__item{width:auto!important;max-width:none!important;margin:0!important}'
      + '@media screen and (min-width:768px) and (max-width:1024px){.collection .product-grid.dd-grid{grid-template-columns:repeat(3,minmax(0,1fr))!important}}'
      + '@media screen and (max-width:767px){.collection .product-grid.dd-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important;row-gap:4rem!important}}';
    var st = document.createElement('style');
    st.id = 'dd-pagenav-css';
    st.textContent = css;
    document.head.appendChild(st);
  }
  function pageNav() {
    var grid = document.querySelector('.collection .product-grid');
    if (!grid) return;
    injectPageNavCss();
    grid.classList.add('dd-grid');
    var host = document.querySelector('.dd-collection-topbar');
    if (!host || host.querySelector('.dd-pagenav')) return;

    var srcPag = document.querySelector('.pagination__list');
    var nav = document.createElement('nav');
    nav.className = 'dd-pagenav';
    nav.setAttribute('aria-label', 'Pagination');
    if (srcPag) {
      [].slice.call(srcPag.querySelectorAll('.pagination__item')).forEach(function (item) {
        if (item.classList.contains('pagination__item-arrow')) return; /* prev/next/first/last arrows: skip, the bottom pagination still has these */
        var txt = (item.textContent || '').trim();
        if (!txt) return;
        var el;
        if (/^\d+$/.test(txt)) {
          if (item.tagName === 'A' && item.getAttribute('href')) {
            el = document.createElement('a');
            el.setAttribute('href', item.getAttribute('href'));
          } else {
            el = document.createElement('span');
          }
          el.textContent = txt;
          if (item.getAttribute('aria-current') || item.className.indexOf('current') >= 0) el.classList.add('is-current');
        } else {
          el = document.createElement('span'); /* the "…" gap marker between non-adjacent page numbers */
          el.textContent = txt;
        }
        nav.appendChild(el);
      });
    }
    if (!nav.children.length) return; /* single page: nothing to paginate */

    host.appendChild(nav); /* dd-collection-topbar is already flex/space-between in the liquid template */
  }

  /* 3) NEW IN (mobile): 화보 full-width, products in a 1-col list of horizontal
        cards (image left + info right); sets slide horizontally. */
  function injectNewinCss() {
    if (document.getElementById('dd-newin-css')) return;
    var css = '@media screen and (max-width:749px){'
      + '[id*="__new_in_sets"] .dd-mob .dd-scroller{display:flex!important;overflow-x:auto!important;scroll-snap-type:x mandatory!important}'
      + '[id*="__new_in_sets"] .dd-mob .dd-slide{flex:0 0 100%!important;width:100%!important;scroll-snap-align:start!important}'
      + '[id*="__new_in_sets"] .dd-mob__hero{aspect-ratio:13/10!important;position:relative!important;overflow:hidden!important;margin-bottom:2rem!important}'
      + '[id*="__new_in_sets"] .dd-mob__hero a{display:block!important;position:absolute!important;inset:0!important;width:100%!important;height:100%!important}'
      + '[id*="__new_in_sets"] .dd-mob__hero img{width:100%!important;height:100%!important;object-fit:cover!important;display:block!important}'
      + '[id*="__new_in_sets"] .dd-mob__row{display:grid!important;grid-template-columns:1fr!important;column-gap:0!important;row-gap:2rem!important}'
      + '[id*="__new_in_sets"] .dd-mob__row product-component,[id*="__new_in_sets"] .dd-mob__row .card-wrapper{display:block!important;width:100%!important}'
      + '[id*="__new_in_sets"] .dd-mob .card-wrapper > div{display:flex!important;flex-direction:row!important;align-items:center!important;gap:1.4rem!important}'
      + '[id*="__new_in_sets"] .dd-mob .card__inner{flex:0 0 40%!important;width:40%!important;max-width:40%!important;aspect-ratio:2/3!important;position:relative!important;overflow:hidden!important;padding:0!important;height:auto!important;--ratio:0.667!important;--preview-ratio:0.667!important}'
      + '[id*="__new_in_sets"] .dd-mob .card__inner .card__media{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;margin:0!important;padding:0!important;aspect-ratio:auto!important}'
      + '[id*="__new_in_sets"] .dd-mob .card__inner .media{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;padding:0!important;aspect-ratio:auto!important}'
      + '[id*="__new_in_sets"] .dd-mob .card__inner img{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;object-fit:contain!important}'
      + '[id*="__new_in_sets"] .dd-mob .card-wrapper > div > .card__content{flex:1 1 auto!important;padding:0!important;text-align:left!important;display:block!important;position:static!important}'
      + '[id*="__new_in_sets"] .dd-mob .card__information{padding:0!important;text-align:left!important}'
      + '[id*="__new_in_sets"] .dd-mob .card__heading,[id*="__new_in_sets"] .dd-mob .card__heading a{font-size:1.4rem!important;text-align:left!important;line-height:1.35!important}'
      + '[id*="__new_in_sets"] .dd-mob .card-information{text-align:left!important}'
      + '[id*="__new_in_sets"] .dd-mob .price{font-size:1.35rem!important;justify-content:flex-start!important;text-align:left!important}'
      + '}';
    var st = document.createElement('style');
    st.id = 'dd-newin-css';
    st.textContent = css;
    (document.body || document.head).appendChild(st);
  }

  /* 4) Header top menu (Matin Kim): icon + text labels, a static
        "한국어 | KRW" locale label, a WISH link, and a cart count. */
  function headerMenu() {
    var icons = document.querySelector('.header .header__icons');
    if (!icons || icons.getAttribute('data-dd-header')) return;
    icons.setAttribute('data-dd-header', '1');

    var loc = icons.querySelector('.desktop-localization-wrapper');
    if (loc) {
      loc.innerHTML = '<a href="#" class="dd-loc" onclick="return false"><span class="dd-globe" aria-hidden="true"><svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.1"><circle cx="10" cy="10" r="8"></circle><ellipse cx="10" cy="10" rx="4" ry="8"></ellipse><line x1="2" y1="10" x2="18" y2="10"></line></svg></span><span class="dd-loc-t">한국어 | KRW</span></a>';
    }

    var cart = icons.querySelector('.header__icon--cart');
    if (cart && !icons.querySelector('.header__icon--wish')) {
      var w = document.createElement('a');
      w.href = '/account';
      w.className = 'header__icon header__icon--wish link';
      w.setAttribute('aria-label', 'Wish');
      w.innerHTML = '<span class="dd-wish-ic" aria-hidden="true">♡</span><span class="dd-hlabel">WISH</span>';
      cart.parentNode.insertBefore(w, cart);
    }

    if (cart && !cart.querySelector('.dd-cart-n')) {
      var bub = cart.querySelector('.cart-count-bubble');
      var n = bub ? ((bub.textContent.match(/\d+/) || ['0'])[0]) : '0';
      var s = document.createElement('span');
      s.className = 'dd-cart-n';
      s.textContent = n;
      cart.appendChild(s);
    }
  }

  /* 5) Mobile menu drawer (Matin Kim): add Search + Wishlist rows into the
        open menu, matching the drawer's Account / locale utility rows. */
  function drawerMenu() {
    var drawer = document.querySelector('.menu-drawer');
    if (!drawer || drawer.querySelector('.dd-drawer-util')) return;
    var util = document.createElement('div');
    util.className = 'dd-drawer-util';
    util.innerHTML =
      '<a href="/search"><span aria-hidden="true"><svg viewBox="0 0 18 18" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.4"><circle cx="7.6" cy="7.6" r="5.4"></circle><line x1="11.6" y1="11.6" x2="16" y2="16"></line></svg></span>Search</a>'
      + '<a href="/account"><span aria-hidden="true"><svg viewBox="0 0 20 20" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M10 16.5S3.8 12.8 3.8 8.4A3.1 3.1 0 0110 6.9a3.1 3.1 0 016.2 1.5c0 4.4-6.2 8.1-6.2 8.1z"></path></svg></span>Wishlist</a>';
    var ul = drawer.querySelector('.menu-drawer__utility-links');
    if (ul) ul.parentNode.insertBefore(util, ul);
    else {
      var nav = drawer.querySelector('.menu-drawer__navigation') || drawer.querySelector('.menu-drawer__inner-container');
      if (nav) nav.appendChild(util);
    }
  }

  /* 6) Footer structure (Matin Kim): links row on top, company info in the
        middle, copyright + Instagram on the bottom row. */
  function footerLayout() {
    var footer = document.querySelector('.footer');
    if (!footer || footer.getAttribute('data-dd-footer')) return;
    var top = footer.querySelector('.footer__content-top');
    var bottom = footer.querySelector('.footer__content-bottom');
    if (!top) return;
    footer.setAttribute('data-dd-footer', '1');
    var policies = footer.querySelector('.policies');
    if (policies) {
      var row = document.createElement('div');
      row.className = 'dd-footer-links page-width';
      row.appendChild(policies);
      footer.insertBefore(row, footer.firstChild);
    }
    var social = footer.querySelector('.footer__list-social');
    if (social && bottom) {
      var wraps = bottom.querySelectorAll('.footer__content-bottom-wrapper');
      var target = wraps.length ? wraps[wraps.length - 1] : bottom;
      var nl = social.closest('.footer-block--newsletter');
      target.appendChild(social);
      if (nl) nl.parentNode && nl.parentNode.removeChild(nl);
    }
  }

  /* 7) Category section: show English category names (from the already-English
        collection handle), without changing the collection title. */
  function catLabels() {
    var map = {
      'new-arrivals': 'NEW ARRIVALS', 'best-sellers': 'BEST SELLERS', 'featured': 'ALL PRODUCTS',
      'tops': 'TOPS', 'bottoms': 'BOTTOMS', 'sets': 'SETS', 'dresses': 'DRESSES',
      'bodysuits': 'BODYSUITS', 'hats': 'HATS', 'bibs': 'BIBS', 'fw-collection': 'FW COLLECTION'
    };
    var links = document.querySelectorAll('.section-collection-list .card__heading a, .collection-list .card__heading a');
    [].forEach.call(links, function (a) {
      var m = (a.getAttribute('href') || '').match(/\/collections\/([^\/?#]+)/);
      if (!m) return;
      var h = decodeURIComponent(m[1]).toLowerCase();
      var label = map[h] || h.replace(/-/g, ' ').toUpperCase();
      for (var i = 0; i < a.childNodes.length; i++) {
        var n = a.childNodes[i];
        if (n.nodeType === 3 && n.textContent.trim()) { n.textContent = label; break; }
      }
    });
  }

  function catLabelFor(h) {
    var map = {
      'new-arrivals': 'NEW ARRIVALS', 'best-sellers': 'BEST SELLERS', 'featured': 'ALL PRODUCTS',
      'tops': 'TOPS', 'bottoms': 'BOTTOMS', 'sets': 'SETS', 'dresses': 'DRESSES',
      'bodysuits': 'BODYSUITS', 'hats': 'HATS', 'bibs': 'BIBS',
      'baby': 'BABY', 'kids': 'KIDS', 'daughter': 'DAUGHTER', 'supima': 'SUPIMA',
      'knit': 'KNIT', 'inner-wear': 'INNER WEAR', 'fw-collection': 'FW COLLECTION'
    };
    h = (h || '').toLowerCase();
    return map[h] || h.replace(/-/g, ' ').toUpperCase();
  }

  /* 8) Collection page: title text = English category label (matches the home
        CATEGORY section labels); MK-measured type is the theme default
        (24px / 400 / left / #1e1e1e / Helvetica Neue + Noto Sans KR). */
  function collTitle() {
    var t = document.querySelector('.collection-hero__title');
    if (!t) return;
    var m = (location.pathname || '').match(/\/collections\/([^\/?#]+)/);
    if (!m) return;
    var label = catLabelFor(decodeURIComponent(m[1]));
    for (var i = t.childNodes.length - 1; i >= 0; i--) {
      var n = t.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) { n.textContent = label; return; }
    }
    t.appendChild(document.createTextNode(label));
  }

  window.addEventListener('load', function () { injectNewinCss(); fixTracks(); collTitle(); pageNav(); headerMenu(); drawerMenu(); footerLayout(); catLabels(); });
})();
